const Points: { [key: number]: number } = {
  0: 1,
  1: 100,
  2: 300,
  3: 500,
  4: 800,
};

export default Points;
